export interface SelectedHourLabelProps {
  /** Offset readout for the selected bucket, e.g. "T+10:00". */
  offsetLabel: string;
  /** Horizontal center of that bucket, as a percentage of the track width. */
  leftPct: number;
}

/**
 * The selected hour's readout, pinned under its bar.
 *
 * This is what identifies the selection now that the tooltip follows only
 * hover/focus (see `TimelineScrubber`) — without it, a selected bucket is
 * distinguishable solely by being a slightly more saturated bar than its
 * neighbours, which is easy to miss on a dense 24-bar track.
 *
 * Always centered on its bucket, including the first and last. The label is
 * allowed to overhang the track there: the axis end-caps sit *beside* the
 * track and their text stops above this strip (they're centered on the
 * axis, which is 20px up), so an overhanging label passes under them
 * without colliding.
 */
export function SelectedHourLabel({ offsetLabel, leftPct }: SelectedHourLabelProps) {
  return (
    <span
      className="pointer-events-none absolute top-0.5 -translate-x-1/2 whitespace-nowrap font-mono text-[0.615em] font-medium text-(--scrubber-accent) [text-shadow:var(--scrubber-halo)] transition-[left] duration-150 ease-out"
      style={{ left: `${leftPct}%` }}
    >
      {offsetLabel}
    </span>
  );
}
